export const bulkActionsMineEntriesTableColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Criado em', value: 'created_at' },
  { label: '', value: 'actions', className: 'w-9' },
];
